export const TRAITS = {
  // Tax
  NOTIFICATION_TAX_EMAIL: 'taxEmail',
  NOTIFICATION_TAX_SMS: 'taxSms',
  NOTIFICATION_TAX_PUSH: 'taxPush',
  // Marketing
  NOTIFICATION_MARKETING_EMAIL: 'marketingEmail',
  NOTIFICATION_MARKETING_SMS: 'marketingSms',
  NOTIFICATION_MARKETING_PUSH: 'marketingPush',
};

export const TAX_NOTIFICATIONS = [
  { name: TRAITS.NOTIFICATION_TAX_EMAIL, label: 'Notifications.Tax.email' },
  { name: TRAITS.NOTIFICATION_TAX_SMS, label: 'Notifications.Tax.sms' },
];

export const MARKETING_NOTIFICATIONS = [
  { name: TRAITS.NOTIFICATION_MARKETING_EMAIL, label: 'Notifications.Marketing.email' },
  { name: TRAITS.NOTIFICATION_MARKETING_PUSH, label: 'Notifications.Marketing.push' },
  { name: TRAITS.NOTIFICATION_MARKETING_SMS, label: 'Notifications.Marketing.sms' },
];
